

import { useCredit } from '../../../hooks'
import ProfessionalChartLoader from '../../../../../common/components/molecule/Chart/ChartLoaderView/ProfessionalChartLoader'
import ChartErrorView from '../../../../../common/components/molecule/Chart/ChartLoaderView/ChartErrorView'
import { createList } from '../../../../../common/utils/graph.utils'
import { formatDateByPeriod } from '../../../../../common/utils/dateFormatter'
import ChartLineView from '../../../../../common/components/molecule/Chart/ChartLineView/ChartLineView'


export default function CreditChartPresenter() {
    const { filter,  creditQuery:query}= useCredit()


      
    if(query.isLoading) {
      return <ProfessionalChartLoader metricName="Crédit" />
  }
  
  if(query.isError && query.error) {
    const error = query.error as Error

    return <ChartErrorView metricName="Crédit" error={error} />
  }
  
  const dataChart = createList(filter.aggregateWindow || '1mo', filter, query.data)
    return (
      <ChartLineView
  
  
      xAxisData ={dataChart.listx.map((item) => formatDateByPeriod(item, filter.aggregateWindow || '1mo'))}
      data ={dataChart.listValue}
      label='Crédit (kWh)'
      unit='kWh'

      />
    )
}
